export { default } from "./SectionTitle";
